/* eslint-disable camelcase */
import { createActions, createReducer } from "reduxsauce";
import  Immutable  from "seamless-immutable";

export const INITIAl_STATE  = Immutable({
  data: {},
  winnerLoading: false,
  loading: false,
})

const {Types, Creators} = createActions({
  getLuckyDrawWinners: ['payload'],
  setLuckyDrawWinners: ['data'],
  setWinnerLoading: ['val'],
  setSingleClaimed: ['payload'],
  setLoading: null,
})

export const setLoadingReducer = (state) => state.set('loading', true)

export const setLuckyDrawWinnersReducer = (state, {data}) => state.set('data', data).set('winnerLoading', false).set('loading', false)

export const setWinnerLoadingReducer = (state, {val}) => state.set('winnerLoading', val)

export const setSingleClaimedReducer = (state, {payload}) => state.setIn(['data', payload.data.id], payload.data)

export const luckyDrawWinnerReducer = createReducer(INITIAl_STATE, {
  [Types.SET_LOADING]: setLoadingReducer,
  [Types.SET_WINNER_LOADING]: setWinnerLoadingReducer,
  [Types.SET_SINGLE_CLAIMED]: setSingleClaimedReducer,
  [Types.SET_LUCKY_DRAW_WINNERS]: setLuckyDrawWinnersReducer,
})
export const LuckyDrawWinnerTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/luckyDrawWinnerReducer.js